import { DestroyRef, Injectable, inject } from '@angular/core';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  InteractionStatus,
  EventMessage,
  EventType,
  RedirectRequest,
  Logger,
  LogLevel,
  AuthenticationResult,
} from '@azure/msal-browser';
import {
  IdTokenClaims,
  Actions as actions,
  featureState,
} from '../store/user/reducer';
import { UserState } from '../store/user/state';
import { Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { GetMeAction } from '../store/me/actions';
import { HttpClient } from '@angular/common/http';
import Me from '../store/me/state';
import { MeState } from '../store/me/reducer';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface Payload extends AuthenticationResult {
  idTokenClaims: {
    tfp?: string;
  };
}

@Injectable()
export class LoginService {
  private destroyRef = inject(DestroyRef);
  error$: Observable<Error>;
  loader: boolean;
  loggedIn: boolean;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private authService: MsalService,
    private userStore: Store<{ userState: featureState }>,
    private meStore: Store<MeState>,
    private http: HttpClient
  ) {}

  logout() {
    this.authService.logout();
    document.location.reload();
  }

  registerHandlers(debugLogin: Boolean) {
    if (debugLogin) {
      this.authService.setLogger(
        new Logger({
          loggerCallback: (logLevel, message, piiEnabled) => {
            // console.log('MSAL Logging: ', message);
          },
          piiLoggingEnabled: true,
          logLevel: LogLevel.Trace,
        })
      );
    }
    this.authService
      .handleRedirectObservable()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: payload => {
          if (payload) {
            var idTokenClaims = payload.idTokenClaims as IdTokenClaims;
            var name: string = idTokenClaims.name;
            name = name.replace(/,/g, '').trim();
            let [lastname, firstname, middle] = name.split(' ');
            var token: string = '';
            var username: string = idTokenClaims.preferred_username;
            var userState: UserState = {
              name: `${firstname} ${lastname}`,
              idTokenClaims: idTokenClaims,
              username: username,
              loggedIn: true,
              error: null,
            };
            this.userStore.dispatch(actions.loginSuccess(userState));
            this.userStore.dispatch(
              actions.loginToken({
                access_token: payload.accessToken,
                // id_token: payload.idToken.rawIdToken,
                id_token: payload.idToken,
                idTokenClaims,
              })
            );
          }
        },
        error: error => {
          console.log('handleredirect error', error);
          return this.authService
            .loginRedirect()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe();
        },
      });
  }


  getMe() {
    return this.http.get<Me>('https://graph.microsoft.com/v1.0/me');
  }

  getGraphUser() {
    this.error$ = this.meStore.select(store => store.error);
    this.meStore.dispatch(new GetMeAction());
  }
}
